import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/themes/prism.css';

interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function JsonEditor({ value, onChange, disabled }: JsonEditorProps) {
  return (
    <div className="json-editor-wrapper border border-gray-300 rounded-lg overflow-hidden">
      <Editor
        value={value}
        onValueChange={onChange}
        highlight={(code) => Prism.highlight(code, Prism.languages.json, 'json')}
        padding={12}
        disabled={disabled}
        style={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          fontSize: 13,
          lineHeight: 1.5,
          minHeight: 384,
          backgroundColor: disabled ? '#f9fafb' : '#ffffff',
        }}
        className="json-editor"
        textareaClassName="json-editor-textarea"
      />
    </div>
  );
}

export function formatJson(json: string): string {
  try {
    return JSON.stringify(JSON.parse(json), null, 2);
  } catch {
    return json;
  }
}
